/**
 * Set cookie.
 *
 * @param cname  Cookie name.
 * @param cvalue Cookie value.
 * @param exdays Number of days the cookie is set to expire in.
 */
function createCookie( cname, cvalue, exdays ) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Get cookie.
 *
 * Can also use: https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#example_2_get_a_sample_cookie_named_test2
 * 
 * @source https://www.w3schools.com/js/js_cookies.asp
 */
function readCookie( name ) {
    name = name + "=";
    var cookies = document.cookie.split(';');
    for(var i = 0; i <cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0)==' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length,cookie.length);
        }
    }
    return "";
}

/**
 * Check cookie.
 */

function checkCookie() {
  var cartCookie = readCookie( "cartinit" );

  if ( cartCookie != "" ) {
    console.log( "Cookie exists. No need to clear the cart. Cookie value: " + cartCookie );
  } else {
      $(function() {
        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          data: '',
          success: function(){
            createCookie( "cartinit", Math.random(), 2 );
            console.log('cart was cleared');
          },
          dataType: 'json'
        });
      });
  }
}

document.addEventListener("DOMContentLoaded", checkCookie ); 
